import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class LoginalertService {

  constructor(private http: HttpClient) { }

  public getJSON(): Observable<any> {
      const url = './json/alertdata.json';
      const delimiter = url.match(/\/$/g) ? '' : '/';
      const urlPath =  `${environment.assetsPath}${delimiter}${url}`;
      return this.http.get(urlPath);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/loginalert.service.ts